import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'

interface AuthState {
  idToken: string
  accessToken: string
}

const initialState: AuthState = {} as AuthState

// Slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIdToken: (state, action: PayloadAction<string>) => {
      state.idToken = action.payload
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload
    },
    clearTokens: (state) => {
      state.idToken = null
      state.accessToken = null
    },
  },
})

// Selectors
export const getIdTokenSelector = (state: RootState): string =>
  state.auth.idToken
export const getAccessTokenSelector = (state: RootState): string =>
  state.auth.accessToken

// Actions
export const { setIdToken, setAccessToken, clearTokens } = authSlice.actions

// Reducers
export default authSlice.reducer
